import { Classes, Colors, Frow, Heading2, IconButton40, IconNames16 } from "@pinpointhq/thumbtack";
import * as React from "react";

interface IDrawerHeaderProps {
  additionalActions?: React.ReactNode;
  title: string;
  handleClose(): void;
}

/**
 * @deprecated Please use the Thumbtack version of this component
 * If it does not cover your use case please speak to Tom Luce
 */
export function DrawerHeader({
  additionalActions,
  handleClose,
  title,
  children,
}: React.PropsWithChildren<IDrawerHeaderProps>) {
  return (
    <div
      className={Classes.DRAWER_HEADER}
      style={{
        backgroundColor: Colors.IVORY_05,
        boxShadow: 'none',
        flexWrap: 'wrap',
        margin: '0',
        padding: '16px 40px',
        alignItems: 'center',
      }}
    >
      <div>
        <Heading2 style={{ marginRight: '24px' }}>{title}</Heading2>
      </div>
      <div>
        <Frow gutters={8} alignItems="center">
          <div>{additionalActions}</div>
          <div>
            <IconButton40
              className={Classes.DIALOG_CLOSE_BUTTON}
              icon={IconNames16.CLOSE}
              aria-label="Close"
              data-testid="close-button"
              onClick={handleClose}
            />
          </div>
        </Frow>
      </div>
      {children}
    </div>
  );
}
